import styled from 'styled-components/macro';

import { rem } from '@blueprint/ui';

import { Link, Icon, ListItem, List } from 'components/blueprint';
import { colors, breakpoints } from 'themes';
import { ScrollContainer } from 'components/ScrollContainer/ScrollContainer';
import { useInteractionTracking } from 'tracking/hooks/useInteractionTracking';
import { ScreenReaderOnly } from 'components/ScreenReaderOnly/ScreenReaderOnly';
import { useSafeLabel } from 'hooks';

import messages from './messages';

const FAQ_CATEGORY_LINK_ID = 'get-support-chatbot-faq-link-description';

const QuestionLink = styled(Link)`
  @media (max-width: ${breakpoints.md}px) {
    && {
      width: 100%;
    }
  }
`;

/**
 * FaqQuestions
 * top FaqQuestions
 */
export const FaqQuestions = ({ questions, onSelectFaq }) => {
  const trackLink = useInteractionTracking('button click');
  const safeLabel = useSafeLabel();

  const handleFaqSelection = (e, question) => {
    e.preventDefault();
    onSelectFaq(question);
  };

  return (
    <ScrollContainer
      sx={{
        flexDirection: 'column',
        flexGrow: 1,
      }}
      aria-describedby={FAQ_CATEGORY_LINK_ID}
    >
      <List paddingLeft={0} listStyleType="none" marginY={0}>
        {!!questions?.length &&
          questions.map((question) => (
            <ListItem key={question.answer_id} paddingY={rem(6)}>
              <QuestionLink
                onClick={trackLink({
                  onClick: (e) => handleFaqSelection(e, question),
                  tealiumData: {
                    event_content: `faq selected: ${question.faqdisplay.toLowerCase()}`,
                  },
                })}
                tabIndex={0}
                href="#"
              >
                {question.faqdisplay}
                <Icon
                  name="ChevronRight"
                  fill={colors.brandChevron}
                  size={rem(12)}
                  top={rem(1)}
                  marginLeft={rem(5)}
                />
              </QuestionLink>
            </ListItem>
          ))}
      </List>
      <ScreenReaderOnly
        aria-live="polite"
        aria-atomic="true"
        id={FAQ_CATEGORY_LINK_ID}
      >
        {questions?.length > 0 &&
          safeLabel(messages.screenReaderText, {
            faqLength: questions.length,
          })}
      </ScreenReaderOnly>
    </ScrollContainer>
  );
};
